import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3Common } from '../../../js/IncludeManager'
import { Big3DatePicker} from '../../../js/ComponentManager'
/* 개발담당:양유빈
 * 화면기능:주문이력 조회
 * 세부설명:
*/

export class OrderSelect extends Component {
    static displayName = OrderSelect.name;

    constructor(props) {
        super(props);
        this.fromDate = format(Big3Common.Util.DateAdd(new Date(), -1), "yyyy-MM-dd");
        this.state = {
            FromDate: this.fromDate,
            Message: "",
            MessageShow: false,
            WholeDataList:[]
        };
        this.ref_OrderSelect = React.createRef();
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleDateSelect_Click = this.handleDateSelect_Click.bind(this);
        this.handleSend_Click = this.handleSend_Click.bind(this);
    }
    //초기화
    componentDidMount() {
    }
    //데이터 초기화
    initOrderSelect = () => {
        this.setState({
            WholeDataList: [],
            Message: "",
            MessageShow: false
        });
        return false;
    }
    //달력일정 변경
    handleCalendarChange(retunValue) {
        let TagId = retunValue.returnId;
        this.setState({ [TagId]: retunValue.SelectDate });
        return false;
    }
    handleDateSelect_Click = async  (event) => {
        if (this.state.FromDate === "") {
            alert("불러올 날짜를 선택하세요");
            return false;
        }
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/ExcelOrder/GetOrderExcelDtlList',
                {
                    order_dt: this.state.FromDate
                });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const WholeDataList = JSON.parse(Data.dataTable);
                if (WholeDataList.length === 0) {
                    this.setState({
                        Message: `${this.state.FromDate}에는 사입주문내역이 없습니다.`,
                        MessageShow: true
                    });
                }
                else {
                    this.setState({
                        WholeDataList: WholeDataList,
                        Message: `주문내역 ${WholeDataList.length}건이 있습니다.`,
                        MessageShow: true
                    });
                }
                                
            }
        }
        catch (e) {
            console.log("handleDateSelect_Click", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        event.preventDefault();
    }
    //적용
    handleSend_Click = (event) => {
        if (this.state.WholeDataList.length === 0) {
            alert("조회내역이 없습니다.");
            return false;
        }
        this.props.CallBack(this.state.WholeDataList);
        event.preventDefault();
    }
    render() {
        return (
            <div ref={this.ref_OrderSelect} className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }}
                id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content">
                        <div className="modal-header EmpDtl_modal_header">
                            <div className="modal-title">{this.props.title}</div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="search_wrap">
                            <div className="select_date_box">
                                <div className="select_date_box_input">
                                    <Big3DatePicker
                                        className="form-control"
                                        setDate={new Date(this.state.FromDate)}
                                        DateChange={this.handleCalendarChange}
                                        id="FromDate"
                                    />
                                    <div className="calendar_btn"></div>
                                </div>
                                <button type="button" className="date_s_btn" onClick={this.handleDateSelect_Click }>조회</button>
                            </div>
                        </div>
                        <div style={{ textAlign: "center", "color": "red", "fontSize": "11pt" }} className={this.state.MessageShow === true ? "" : "item_hide"}>{this.state.Message}</div>
                        <div>
                        </div>
                        <div className="modal-footer notice_modal_footer">
                            <button type="button"
                                className="m_btn"
                                onClick={this.handleSend_Click }
                                >적용
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
